import { PropsWithChildren } from "react";
import MetaTags from "@/components/MetaTags";
import { FlashMessages } from "@/components/FlashMessages";

export default function Layout({ children }: PropsWithChildren) {
  return (
    <>
      <MetaTags />
      <FlashMessages />
      <main>{children}</main>
    </>
  );
}
